import { useTranslation } from 'react-i18next';

export default function CoreLogic() {
  const { t } = useTranslation();
  const steps = [
    {
      icon: 'ri-database-2-line',
      title: t('coreLogic.step0_title'),
      subtitle: t('coreLogic.step0_sub'),
      items: [t('coreLogic.step0_i0'), t('coreLogic.step0_i1'), t('coreLogic.step0_i2'), t('coreLogic.step0_i3')]
    },
    {
      icon: 'ri-brain-line',
      title: t('coreLogic.step1_title'),
      subtitle: t('coreLogic.step1_sub'),
      items: [t('coreLogic.step1_i0'), t('coreLogic.step1_i1'), t('coreLogic.step1_i2'), t('coreLogic.step1_i3')]
    },
    {
      icon: 'ri-search-eye-line',
      title: t('coreLogic.step2_title'),
      subtitle: t('coreLogic.step2_sub'),
      items: [t('coreLogic.step2_i0'), t('coreLogic.step2_i1'), t('coreLogic.step2_i2'), t('coreLogic.step2_i3')]
    },
    {
      icon: 'ri-flashlight-line',
      title: t('coreLogic.step3_title'),
      subtitle: t('coreLogic.step3_sub'),
      items: [t('coreLogic.step3_i0'), t('coreLogic.step3_i1'), t('coreLogic.step3_i2'), t('coreLogic.step3_i3')]
    },
    {
      icon: 'ri-refresh-line',
      title: t('coreLogic.step4_title'),
      subtitle: t('coreLogic.step4_sub'),
      items: [t('coreLogic.step4_i0'), t('coreLogic.step4_i1'), t('coreLogic.step4_i2'), t('coreLogic.step4_i3')]
    }
  ];

  return (
    <section id="core-logic" className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #100b1e 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-60" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[450px] rounded-full opacity-12"
          style={{ background: 'radial-gradient(ellipse, rgba(168,85,247,0.4) 0%, transparent 70%)' }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <div className="badge-purple mb-6">
            <i className="ri-cpu-line text-xs"></i>
            {t('coreLogic.badge')}
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight font-heading">
            {t('coreLogic.title1')}
            <br />
            <span className="text-gradient-aurora">{t('coreLogic.title2')}</span>
          </h2>
          <p className="text-lg text-white/45 max-w-3xl mx-auto leading-relaxed">
            {t('coreLogic.desc')}
          </p>
        </div>

        {/* Timeline Flow */}
        <div className="relative">
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-px"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(168,85,247,0.2), transparent)' }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="group">
                <div className="premium-card premium-card-hover rounded-2xl p-6 h-full">
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl bg-purple-400/10 border border-purple-400/20 flex items-center justify-center mb-4 group-hover:bg-purple-400/18 transition-colors">
                    <i className={`${step.icon} text-xl text-purple-400`}></i>
                  </div>

                  <h3 className="text-base font-bold text-white mb-1 font-heading">{step.title}</h3>
                  <p className="text-xs text-purple-400 font-medium mb-4">{step.subtitle}</p>

                  <ul className="space-y-2">
                    {step.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-white/50">
                        <i className="ri-arrow-right-s-line text-purple-500/60 mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Key Point */}
        <div className="mt-16 rounded-2xl p-8 border border-purple-400/15"
          style={{ background: 'linear-gradient(135deg, rgba(147,51,234,0.08), rgba(124,58,237,0.04))' }}>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-purple-400/12 border border-purple-400/22 flex items-center justify-center flex-shrink-0"
              style={{ boxShadow: '0 0 16px rgba(168,85,247,0.2)' }}>
              <i className="ri-lightbulb-flash-line text-xl text-purple-400"></i>
            </div>
            <div>
              <h4 className="text-lg font-bold text-white mb-2 font-heading">{t('coreLogic.keyTitle')}</h4>
              <p className="text-white/50 leading-relaxed text-base">
                PolyAi-Claw {t('coreLogic.keyDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
